import { render, staticRenderFns } from "./BlockType103.vue?vue&type=template&id=579c2705"
import script from "./BlockType103.vue?vue&type=script&lang=ts"
export * from "./BlockType103.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports